import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-inizio',
  templateUrl: './inizio.page.html',
  styleUrls: ['./inizio.page.scss'],
})
export class InizioPage implements OnInit {

  constructor(private modalCtrl: ModalController, private storage: Storage) {
   }

  ngOnInit() {
  }

  buttonok(){
    this.storage.set("foglio", "true");
    this.modalCtrl.dismiss();
  }


}
